import React, { useState } from "react"
import {
  Paper,
  Grid,
  TextField,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core"
import { UserConsumer } from "../contexts/UserContext"
import { login } from "../api/login"
import { Alert, AlertTitle } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  form: {
    width: "400px",
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  padding: {
    padding: theme.spacing.unit,
  },
  errorAlert: {
    marginTop: 10,
  },
}))

const LoginPage = () => {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const classes = useStyles()

  const handleInputChange = (e) => {
    if (e.target.name === "email") {
      setEmail(e.target.value)
    } else {
      setPassword(e.target.value)
    }
  }
  const handleKeyDown = (e, onLogin) => {
    if (e.key === "Enter") {
      handleSubmit(e, onLogin)
    }
  }
  const handleSubmit = (e, onLogin) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    login(email, password)
      .then((user) => {
        setLoading(false)
        onLogin(user)
      })
      .catch((error) => {
        setError(error)
        setLoading(false)
      })
  }

  return (
    <UserConsumer className={classes.root}>
      {({ onLogin }) => (
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "100vh" }}
        >
          <Paper className={`${classes.padding} ${classes.form}`}>
            <div className={classes.margin}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                HMI Capital One Reporting
              </Typography>
              <Grid container spacing={8} alignItems="flex-end">
                <Grid item md={true} sm={true} xs={true}>
                  <TextField
                    error={error && error.type === "user"}
                    id="email"
                    label="Email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => handleInputChange(e)}
                    fullWidth
                    autoFocus={true}
                    helperText={error && error.type === "user" ? error.message : ""}
                    required
                    onKeyDown={(e) => handleKeyDown(e, onLogin)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={8} alignItems="flex-end">
                <Grid item md={true} sm={true} xs={true}>
                  <TextField
                    error={error && error.type === "password"}
                    id="password"
                    label="Password"
                    type="password"
                    name="password"
                    value={password}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    onKeyDown={(e) => handleKeyDown(e, onLogin)}
                    helperText={
                      error && error.type === "password" ? error.message : ""
                    }
                  />
                </Grid>
              </Grid>
              <Grid container alignItems="center" justify="space-between">
                <Grid container justify="center" style={{ marginTop: "10px" }}>
                  <Button
                    error={error && error.type === "password"}
                    variant="contained"
                    color="primary"
                    style={{ minWidth: "200px" }}
                    disabled={loading}
                    disableRipple
                    disableFocusRipple
                    onClick={(e) => handleSubmit(e, onLogin)}
                  >
                    Login
                  </Button>
                  {error && error.type === "system" && (
                    <Alert className={classes.errorAlert} severity="error">
                      <AlertTitle>Error</AlertTitle>
                      {error.message}
                    </Alert>
                  )}
                </Grid>
              </Grid>
            </div>
          </Paper>
        </Grid>
      )}
    </UserConsumer>
  )
}

export default LoginPage
